import filter from "lodash/filter";
import {
  dateTimeStringToDate,
  differenceInMinutes,
  differenceInDays,
} from "../../../common/helpers/time";

class CreateReportCardController {
  constructor(
    $state,
    $stateParams,
    DrivesModel,
    FlashService,
    ReportcardsModel,
    tasks,
    student,
    $window,
    GradeOptionModel,
    $q,
  ) {
    this.loading = true;
    this.$window = $window;
    this.$stateParams = $stateParams;
    this.drive = {};
    this.gradeOptions = [
      {
        name: "Awesome job!",
        value: "green",
        color: "#64BC5F",
      },
      {
        name: "Good, but not great!",
        value: "yellow",
        color: "#F9C932",
      },
      {
        name: "Needs work, keep practicing!",
        value: "red",
        color: "#FF4646",
      },
      {
        name: "Not Covered",
        value: "grey",
        color: "#cccccc",
      },
    ];
    this.tasks = tasks.map((task) => {
      task.grade = this.gradeOptions[3];
      return task;
    });

    $q.all([
      GradeOptionModel.getGradeOptions(),
      DrivesModel.getDriveByID($stateParams.driveId),
    ]).then((responses) => {
      if (responses[0].grade_options.length > 0) {
        this.gradeOptions = responses[0].grade_options.map((option) => {
          return {
            name: option.option_name,
            value: option.option_value,
            color: option.option_color,
          };
        });
      }

      this.drive = responses[1].drive;
      this.driveDate = dateTimeStringToDate(
        this.drive.drive_date + " " + this.drive.start_time,
      );
      this.untilDrive = this.getRelativeTime(this.driveDate);
      this.loading = false;
    });

    this.grades = [];
    this.gradeIncomplete = true;
    this.reportcard = {
      student: {
        firstname: student.firstname,
        lastname: student.lastname,
      },
    };

    this.$state = $state;
    this.DrivesModel = DrivesModel;
    this.FlashService = FlashService;
    this.ReportcardsModel = ReportcardsModel;
  }

  getRelativeTime(date) {
    const now = new Date();
    const diffMinutes = differenceInMinutes(date, now);
    const diffDays = differenceInDays(date, now);

    if (Math.abs(diffMinutes) < 60) {
      if (diffMinutes > 0) {
        return `in ${Math.abs(diffMinutes)} minutes`;
      } else {
        return `${Math.abs(diffMinutes)} minutes ago`;
      }
    } else if (Math.abs(diffDays) < 1) {
      const hours = Math.floor(Math.abs(diffMinutes) / 60);
      if (diffMinutes > 0) {
        return `in ${hours} hours`;
      } else {
        return `${hours} hours ago`;
      }
    } else {
      if (diffDays > 0) {
        return `in ${diffDays} days`;
      } else {
        return `${Math.abs(diffDays)} days ago`;
      }
    }
  }

  getGrades(tasks) {
    const grades = [];
    tasks.forEach((task) => {
      grades.push({
        task_id: task.id,
        student_id: this.reportcard.student_id,
        name: task.name,
        status: task.grade.value,
      });
    });
    return grades;
  }

  submitGrades(isValid) {
    if (this.busy) {
      return;
    }

    this.submitted = true;

    if (isValid) {
      const grades = this.getGrades(this.tasks);
      const data = {
        drive_id: this.$stateParams.driveId,
        grades: grades,
        internal_note: this.internal_note,
        external_note: this.external_note,
      };

      this.busy = true;
      this.ReportcardsModel.submitGrades(data)
        .then((response) => {
          this.FlashService.setMessage({
            type: "success",
            message: response.message,
          });
          this.submitted = false;
          this.busy = false;
          this.$state.go("drivecoach.admin.reportcards");
        })
        .catch(() => {
          this.submitted = false;
          this.busy = false;
        });
    } else {
      this.FlashService.setMessage({
        type: "error",
        message: "Please complete the grades.",
      });
    }
  }

  checkGrade() {
    this.gradeIncomplete =
      filter(this.tasks, "grade").length < this.tasks.length;
  }

  deleteReportCard(reportcard_id) {
    const confirm = this.$window.confirm(
      "Are you sure you want to delete this report card? THIS CANNOT BE UNDONE.",
    );
    if (confirm === false) {
      return;
    }
    this.busy = true;
    this.ReportcardsModel.destroy({ id: reportcard_id })
      .then((response) => {
        this.busy = false;
        this.$state.go("drivecoach.admin.reportcards");
        this.FlashService.setMessage({
          type: "success",
          message: response.message,
        });
      })
      .catch((Error) => {
        this.busy = false;
      });
  }
}
CreateReportCardController.$inject = [
  "$state",
  "$stateParams",
  "DrivesModel",
  "FlashService",
  "ReportcardsModel",
  "tasks",
  "student",
  "$window",
  "GradeOptionModel",
  "$q",
];

export default CreateReportCardController;
